import React, { useContext } from 'react'
import { PlayerProfileContext } from '../../Context'
import { Box } from '../../Components/Layout'
import { SeasonSelector } from './components'
import { CurrentSeasonStats } from './components/stats/currentSeason/CurrentSeasonStats'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { StatsTabs } from './components/stats/statsTabs/StatsTabs'

export const StatsTab: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, getPlayerLeague } = useContext(PlayerProfileContext)!
  const league = getPlayerLeague('stats')

  return (
    <>
      <Box>
        <SeasonSelector
          allYears={player?.allYears}
          isActive={player?.status === 'current'}
        />

        <CurrentSeasonStats league={league} />

        <StatsTabs />

      </Box>
      <AdUnit bannerType="bannerSecond" aria-label="Player stats ad second" />
    </>
  )
}
